import { Expose, Transform } from "class-transformer";
import { toCents, toMinutes } from "@/utils/numberUtils";
import { CollectiveAgreementWeekendDayEnum } from "@altertec_gparn/lib";

export class CreateCollectiveAgreementDto {
  @Expose()
  name: string;

  @Expose()
  holidayDaysPerYear: number;

  @Expose()
  zoneCoding: string;

  @Expose()
  @Transform(({ value }) => toMinutes(value))
  numberOfHours: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  exemptKmPrice: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  taxableKmPrice: number;

  @Expose()
  weekendDays: CollectiveAgreementWeekendDayEnum[];
}
